import * as types from './type';
import { Ads }  from  '../../services/ads';

export function setPostAdsStep1Data(data) {
    return {
      type: types.SET_PROPERTY_DATA,
      payload: data,
    };
};
export function setPostAdsStep2Data(data) {
  return {
    type: types.SET_PROPERTY_STEP2_DATA,
    payload: data,
  };
};
export function postAd(data) {
  return {
    type: types.POST_A_ADD,
    payload: Ads.postAd(data),
  };
};

export function validatePropertyTitle(data) {
  return {
    type: types.VALIDATE_PROPERTY_TITLE,
    payload: Ads.validatePropertyTitle(data),
  };
};



